
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class TaxSelectGrid extends Serenity.EntityGrid<TaxRow, any> {
        protected getColumnsKey() { return 'OMS.Tax'; }
        protected getDialogType() { return <any>TaxDialog; }
        protected getIdProperty() { return TaxRow.idProperty; }
        protected getLocalTextPrefix() { return TaxRow.localTextPrefix; }
        protected getService() { return TaxService.baseUrl; }
        //protected getInsertPermission() { return TaxRow.insertPermission; }
        //protected getUpdatePermission() { return TaxRow.updatePermission; }
        //protected getDeletePermission() { return TaxRow.deletePermission; }
        //protected useViewMode() { return true; }
        private rowSelection: Serenity.GridRowSelectionMixin;
        static applicableon: string;
        protected getColumns() {
            var _this = this;
            var columns = super.getColumns.call(this);
            columns.splice(0, 0, Serenity.GridRowSelectionMixin.createSelectColumn(function () { return _this.rowSelection; }));
            return columns;
        };

        constructor(container: JQuery) {
            super(container);
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
            return this;
        }

        get selectedItems(): TaxRow[] {
                var _this = this;
                return this.rowSelection.getSelectedAsInt32().map(function (x) { return _this.view.getItemById(x); });
            }

        protected usePager() { return false; };
        protected getInitialTitle() { return null; };

        protected getButtons() {
            var buttons = super.getButtons.call(this);
            buttons = buttons.filter(function (x) { return x.cssClass != 'add-button'; });
            return buttons;
        };


        protected onViewSubmit() {
            if (!super.onViewSubmit.call(this))
                return false;
            var request = this.view.params as Serenity.ListRequest;
            if (TaxSelectGrid.applicableon !="")
                request.Criteria = Serenity.Criteria.and(request.Criteria,
                    [['ApplicableOn'], '=', TaxSelectGrid.applicableon]);

            return true;

        }
        
    }

    export interface ProductSelectOptions {
        ParentKey?: string;
        Key?: string;
        Title?: string;
        IsGroup?: boolean;
        GrantRevoke?: boolean;
    }
}